import { NavItem } from './nav-item/nav-item';

export const navItems: NavItem[] = [
  {
    displayName: 'Dashboard',
    iconName: 'dashboard',
    route: '/dashboard',
  },
  {
    displayName: 'Patient',
    iconName: 'home',
    route: '/patient',
  },
  {
    displayName: 'Appointment',
    iconName: 'lock',
    route: '/appointment',
  },
  {
    displayName: 'IPD',
    iconName: 'bed',
    route: '/ipd/management',
    requiresIPD: true,
  },
  {
    displayName: 'Pharmacy',
    iconName: 'pill',
    route: '/pharmacy',
  },
  {
    displayName: 'Report',
    iconName: 'box-multiple',
    children: [
      {
        displayName: 'Patient Report(OPD)',
        iconName: 'point',
        openDialog: true,
      },
      {
        displayName: 'Billing Report',
        iconName: 'point',
        route: '/report/billing',
      },
    ]
    // children: [
    //   {
    //     displayName: 'Patient ALL',
    //     iconName: 'point',
    //     route: '/menu-1',
    //   }
    // ]
  }
  // {
  //   displayName: 'Report',
  //   iconName: 'box-multiple',
  //   route: '/menu-level',
  //   children: [
  //     {
  //       displayName: 'Patient ALL',
  //       iconName: 'point',
  //       route: '/menu-1',
  //     },
  //     {
  //       displayName: 'Patient IPD',
  //       iconName: 'point',
  //       route: '/menu-2',
  //     },
  //     {
  //       displayName: 'Patient OPD',
  //       iconName: 'point',
  //       route: '/menu-2',
  //     },
  //   ],
  // },
  // {
  //   displayName: 'Disabled',
  //   iconName: 'ban',
  //   route: '/disabled',
  //   disabled: true,
  // },
  // {
  //   displayName: 'Chip',
  //   iconName: 'mood-smile',
  //   route: '/',
  //   chip: true,
  //   chipClass: 'bg-primary text-white',
  //   chipContent: '9',
  // },
  // {
  //   displayName: 'Outlined',
  //   iconName: 'mood-smile',
  //   route: '/',
  //   chip: true,
  //   chipClass: 'b-1 border-primary text-primary',
  //   chipContent: 'outlined',
  // },
  // {
  //   displayName: 'External Link',
  //   iconName: 'star',
  //   route: 'https://www.google.com/',
  //   external: true,
  // },
];
